/* @generated from adl module ferovinum.app.config */

import * as ADL from './../../runtime/adl';
import * as common_config_aws from './../../common/config/aws';
import * as common_config_db from './../../common/config/db';
import * as common_config_flyway from './../../common/config/flyway';
import * as common_config_frontend from './../../common/config/frontend';
import * as common_config_log from './../../common/config/log';
import * as common_strings from './../../common/strings';

/**
 * Configuration for the server
 * Mock dashboard provider configuration (for local development)
 */
export interface MockDashboardConfig {
  /**
   * Whether mock provider is enabled
   */
  enabled: boolean;
  /**
   * Display name for the mock provider
   */
  displayName: string;
  /**
   * Base URL for mock embeds (serves a placeholder page)
   * For local dev, this should be a page that shows mock dashboard info
   */
  embedUrl: string;
}

export function makeMockDashboardConfig(
  input: {
    enabled?: boolean,
    displayName?: string,
    embedUrl?: string,
  }
): MockDashboardConfig {
  return {
    enabled: input.enabled === undefined ? true : input.enabled,
    displayName: input.displayName === undefined ? "Mock Provider (Development)" : input.displayName,
    embedUrl: input.embedUrl === undefined ? "about:blank" : input.embedUrl,
  };
}

const MockDashboardConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[{"value":"Configuration for the server\nMock dashboard provider configuration (for local development)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Whether mock provider is enabled\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"enabled","default":{"kind":"just","value":true},"name":"enabled","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"value":"Display name for the mock provider\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"displayName","default":{"kind":"just","value":"Mock Provider (Development)"},"name":"displayName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Base URL for mock embeds (serves a placeholder page)\nFor local dev, this should be a page that shows mock dashboard info\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"embedUrl","default":{"kind":"just","value":"about:blank"},"name":"embedUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"MockDashboardConfig","version":{"kind":"nothing"}}};

export const snMockDashboardConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"MockDashboardConfig"};

export function texprMockDashboardConfig(): ADL.ATypeExpr<MockDashboardConfig> {
  return {value : {typeRef : {kind: "reference", value : snMockDashboardConfig}, parameters : []}};
}

export interface QuickSightConfig {
  /**
   * AWS Account ID where QuickSight is deployed
   */
  awsAccountId: string;
  /**
   * AWS region for QuickSight (default: eu-west-2)
   */
  awsRegion: string;
  /**
   * QuickSight namespace (default: default)
   */
  namespace: string;
  /**
   * Allowed domains for embedding
   */
  allowedDomains: string[];
  /**
   * Session duration in seconds (default: 900 = 15 minutes, QuickSight minimum)
   */
  sessionDurationSeconds: number;
  /**
   * Optional explicit AWS credentials for QuickSight (for local dev).
   * If not provided, uses default credential chain.
   */
  accessKeyId: (string|null);
  secretAccessKey: (string|null);
  sessionToken: (string|null);
}

export function makeQuickSightConfig(
  input: {
    awsAccountId: string,
    awsRegion?: string,
    namespace?: string,
    allowedDomains: string[],
    sessionDurationSeconds?: number,
    accessKeyId?: (string|null),
    secretAccessKey?: (string|null),
    sessionToken?: (string|null),
  }
): QuickSightConfig {
  return {
    awsAccountId: input.awsAccountId,
    awsRegion: input.awsRegion === undefined ? "eu-west-2" : input.awsRegion,
    namespace: input.namespace === undefined ? "default" : input.namespace,
    allowedDomains: input.allowedDomains,
    sessionDurationSeconds: input.sessionDurationSeconds === undefined ? 900 : input.sessionDurationSeconds,
    accessKeyId: input.accessKeyId === undefined ? null : input.accessKeyId,
    secretAccessKey: input.secretAccessKey === undefined ? null : input.secretAccessKey,
    sessionToken: input.sessionToken === undefined ? null : input.sessionToken,
  };
}

const QuickSightConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"AWS Account ID where QuickSight is deployed\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"awsAccountId","default":{"kind":"nothing"},"name":"awsAccountId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"AWS region for QuickSight (default: eu-west-2)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"awsRegion","default":{"kind":"just","value":"eu-west-2"},"name":"awsRegion","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"QuickSight namespace (default: default)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"namespace","default":{"kind":"just","value":"default"},"name":"namespace","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Allowed domains for embedding\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"allowedDomains","default":{"kind":"nothing"},"name":"allowedDomains","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"value":"Session duration in seconds (default: 900 = 15 minutes, QuickSight minimum)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"sessionDurationSeconds","default":{"kind":"just","value":900},"name":"sessionDurationSeconds","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"value":"Optional explicit AWS credentials for QuickSight (for local dev).\nIf not provided, uses default credential chain.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"accessKeyId","default":{"kind":"just","value":null},"name":"accessKeyId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"secretAccessKey","default":{"kind":"just","value":null},"name":"secretAccessKey","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"sessionToken","default":{"kind":"just","value":null},"name":"sessionToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"QuickSightConfig","version":{"kind":"nothing"}}};

export const snQuickSightConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"QuickSightConfig"};

export function texprQuickSightConfig(): ADL.ATypeExpr<QuickSightConfig> {
  return {value : {typeRef : {kind: "reference", value : snQuickSightConfig}, parameters : []}};
}

/**
 * Databricks dashboard embedding configuration
 */
export interface DatabricksConfig {
  /**
   * Databricks workspace instance URL (e.g., "https://xxxx.cloud.databricks.com")
   */
  instanceUrl: common_strings.StringNE;
  /**
   * Databricks workspace ID
   */
  workspaceId: common_strings.StringNE;
  /**
   * AWS Secrets Manager secret name holding per-org service principal credentials (for embedding)
   */
  orgSecretName: common_strings.StringNE;
  /**
   * AWS Secrets Manager secret name for the backend admin SA (for tags, permissions, eligibility)
   */
  backendSecretName: (string|null);
  /**
   * Key within the backend secret's service_account map (e.g., "dashboard_embed")
   */
  backendCredentialKey: (string|null);
}

export function makeDatabricksConfig(
  input: {
    instanceUrl: common_strings.StringNE,
    workspaceId: common_strings.StringNE,
    orgSecretName: common_strings.StringNE,
    backendSecretName?: (string|null),
    backendCredentialKey?: (string|null),
  }
): DatabricksConfig {
  return {
    instanceUrl: input.instanceUrl,
    workspaceId: input.workspaceId,
    orgSecretName: input.orgSecretName,
    backendSecretName: input.backendSecretName === undefined ? null : input.backendSecretName,
    backendCredentialKey: input.backendCredentialKey === undefined ? null : input.backendCredentialKey,
  };
}

const DatabricksConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[{"value":"Databricks dashboard embedding configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Databricks workspace instance URL (e.g., \"https://xxxx.cloud.databricks.com\")\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"instanceUrl","default":{"kind":"nothing"},"name":"instanceUrl","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Databricks workspace ID\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"workspaceId","default":{"kind":"nothing"},"name":"workspaceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"AWS Secrets Manager secret name holding per-org service principal credentials (for embedding)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"orgSecretName","default":{"kind":"nothing"},"name":"orgSecretName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"AWS Secrets Manager secret name for the backend admin SA (for tags, permissions, eligibility)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"backendSecretName","default":{"kind":"just","value":null},"name":"backendSecretName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"value":"Key within the backend secret's service_account map (e.g., \"dashboard_embed\")\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"backendCredentialKey","default":{"kind":"just","value":null},"name":"backendCredentialKey","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"DatabricksConfig","version":{"kind":"nothing"}}};

export const snDatabricksConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"DatabricksConfig"};

export function texprDatabricksConfig(): ADL.ATypeExpr<DatabricksConfig> {
  return {value : {typeRef : {kind: "reference", value : snDatabricksConfig}, parameters : []}};
}

export interface EmbeddedDashboardProviderConfig_Mock {
  kind: 'mock';
  value: MockDashboardConfig;
}
export interface EmbeddedDashboardProviderConfig_Quicksight {
  kind: 'quicksight';
  value: QuickSightConfig;
}
export interface EmbeddedDashboardProviderConfig_Databricks {
  kind: 'databricks';
  value: DatabricksConfig;
}

/**
 * Discriminated union of all possible dashboard provider configurations
 */
export type EmbeddedDashboardProviderConfig = EmbeddedDashboardProviderConfig_Mock | EmbeddedDashboardProviderConfig_Quicksight | EmbeddedDashboardProviderConfig_Databricks;

export interface EmbeddedDashboardProviderConfigOpts {
  /**
   * Mock provider for local development (no AWS required)
   */
  mock: MockDashboardConfig;
  /**
   * AWS QuickSight provider
   */
  quicksight: QuickSightConfig;
  /**
   * Databricks AI/BI embedding provider
   */
  databricks: DatabricksConfig;
}

export function makeEmbeddedDashboardProviderConfig<K extends keyof EmbeddedDashboardProviderConfigOpts>(kind: K, value: EmbeddedDashboardProviderConfigOpts[K]) { return {kind, value}; }

const EmbeddedDashboardProviderConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[{"value":"Discriminated union of all possible dashboard provider configurations\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Mock provider for local development (no AWS required)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"mock","default":{"kind":"nothing"},"name":"mock","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"MockDashboardConfig"}},"parameters":[]}},{"annotations":[{"value":"AWS QuickSight provider\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"quicksight","default":{"kind":"nothing"},"name":"quicksight","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"QuickSightConfig"}},"parameters":[]}},{"annotations":[{"value":"Databricks AI/BI embedding provider\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"databricks","default":{"kind":"nothing"},"name":"databricks","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"DatabricksConfig"}},"parameters":[]}}]}},"name":"EmbeddedDashboardProviderConfig","version":{"kind":"nothing"}}};

export const snEmbeddedDashboardProviderConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"EmbeddedDashboardProviderConfig"};

export function texprEmbeddedDashboardProviderConfig(): ADL.ATypeExpr<EmbeddedDashboardProviderConfig> {
  return {value : {typeRef : {kind: "reference", value : snEmbeddedDashboardProviderConfig}, parameters : []}};
}

/**
 * Configuration for embedded dashboards feature
 */
export interface EmbeddedDashboardConfig {
  /**
   * List of configured providers (first matching provider is used)
   */
  providers: EmbeddedDashboardProviderConfig[];
}

export function makeEmbeddedDashboardConfig(
  input: {
    providers: EmbeddedDashboardProviderConfig[],
  }
): EmbeddedDashboardConfig {
  return {
    providers: input.providers,
  };
}

const EmbeddedDashboardConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[{"value":"Configuration for embedded dashboards feature\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"List of configured providers (first matching provider is used)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"providers","default":{"kind":"nothing"},"name":"providers","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"EmbeddedDashboardProviderConfig"}},"parameters":[]}]}}]}},"name":"EmbeddedDashboardConfig","version":{"kind":"nothing"}}};

export const snEmbeddedDashboardConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"EmbeddedDashboardConfig"};

export function texprEmbeddedDashboardConfig(): ADL.ATypeExpr<EmbeddedDashboardConfig> {
  return {value : {typeRef : {kind: "reference", value : snEmbeddedDashboardConfig}, parameters : []}};
}

export interface ServerConfig {
  /**
   * Port to listen for requests
   */
  port: number;
  /**
   * Environment name, e.g. dev, uat, prod
   */
  environment: string;
  /**
   * Name of the release / code version
   */
  releaseName: string;
  /**
   * The shared secret that will be present on requests from the queue
   * processor system
   */
  processorSecret: string;
  /**
   * Secret used to sign JWT tokens
   */
  jwtSecret: string;
  /**
   * Database config
   */
  db: common_config_db.PostgreSqlConfig;
  /**
   * Cron-specific configuration
   */
  cronDb: common_config_db.PostgreSqlConfig;
  /**
   * Server-side logging config
   */
  logging: common_config_log.LogConfig;
  /**
   * Client-side logging config
   */
  clientLogging: ClientLogConfig;
  /**
   * Frontend threadpool configuration
   */
  threadPool: common_config_frontend.ThreadPoolConfig;
  flyway: (common_config_flyway.FlywayConfig|null);
  secretUrls: SecretUrls;
  awsRegion: common_config_aws.AwsRegionProvider;
  emailNotificationsConfig: EmailNotificationsConfig;
  trueLayerApi: TrueLayerApiConfig;
  visionApis: VisionApiConfig[];
  bloomberg: BloombergConfig;
  blobStoreConfig: BlobStoreConfig;
  localBlobStoreConfig: (LocalBlobStoreConfig|null);
  freightTransportApi: FreightTransportApiConfig;
  hotjarConfig: HotjarConfig;
  googleAnalyticsConfig: GoogleAnalyticsConfig;
  /**
   * PostHog configuration
   */
  postHogConfig: PostHogConfig;
  /**
   * The app url for the current environment
   */
  appBaseUrl: string;
  useLocalstack: boolean;
  localstackHost: string;
  /**
   * The queues that are used to broadcast messages to the Fero ecosystem and
   * to receive feedback from the various services.
   */
  messageQueueConfig: MessageQueueConfig;
  /**
   * The domain of the accounting service to use
   */
  accountingServiceDomain: string;
  /**
   * The base URL of the Accounting API
   */
  accountingApiUrl: string;
  /**
   * API key for the Accounting API
   */
  accountingApiKey: string;
  purchaseRequestTimelineDurations: PurchaseRequestTimelineDurations;
  amsterdamWarehouseCompany: AmsterdamWarehouseCompany;
  /**
   * Indicates whether the instance is a reporting instance
   */
  isReportingInstance: boolean;
  reportingStoreConfig: ReportingStoreConfig;
  apiDeckApi: ApiDeckApiConfig;
  shipEngineApi: ShipEngineApiConfig;
  docuSignApi: DocuSignApiConfig;
  fronteggConfig: FronteggConfig;
  /**
   * Configuration for Raw Data extraction jobs
   */
  rawExportConfig: RawExportConfig;
  /**
   * The hostname of the node server. Value should be null if one should not be started
   */
  nodeServerHostname: string;
  /**
   * Secret used to authenticate internal API calls between Java and Node appserver
   */
  internalApiSecret: string;
  /**
   * Leave this as the last entry please.
   */
  devConfig: DevConfig;
  httpRateLimitDefault: number;
  httpRateLimitHighFrequent: number;
  /**
   * The domain of the API eg. https://api.fero.capital
   */
  apiDomainUrl: string;
  corsAllowedOrigins: string[];
  /**
   * Embedded dashboard configuration (optional - only needed if using embedded dashboards)
   * Configure providers in the list (mock for local dev, quicksight for production)
   */
  embeddedDashboardConfig: (EmbeddedDashboardConfig|null);
}

export function makeServerConfig(
  input: {
    port: number,
    environment: string,
    releaseName: string,
    processorSecret: string,
    jwtSecret: string,
    db: common_config_db.PostgreSqlConfig,
    cronDb: common_config_db.PostgreSqlConfig,
    logging: common_config_log.LogConfig,
    clientLogging?: ClientLogConfig,
    threadPool: common_config_frontend.ThreadPoolConfig,
    flyway?: (common_config_flyway.FlywayConfig|null),
    secretUrls: SecretUrls,
    awsRegion: common_config_aws.AwsRegionProvider,
    emailNotificationsConfig: EmailNotificationsConfig,
    trueLayerApi: TrueLayerApiConfig,
    visionApis: VisionApiConfig[],
    bloomberg: BloombergConfig,
    blobStoreConfig: BlobStoreConfig,
    localBlobStoreConfig: (LocalBlobStoreConfig|null),
    freightTransportApi: FreightTransportApiConfig,
    hotjarConfig: HotjarConfig,
    googleAnalyticsConfig: GoogleAnalyticsConfig,
    postHogConfig: PostHogConfig,
    appBaseUrl: string,
    useLocalstack?: boolean,
    localstackHost?: string,
    messageQueueConfig: MessageQueueConfig,
    accountingServiceDomain: string,
    accountingApiUrl: string,
    accountingApiKey: string,
    purchaseRequestTimelineDurations: PurchaseRequestTimelineDurations,
    amsterdamWarehouseCompany: AmsterdamWarehouseCompany,
    isReportingInstance: boolean,
    reportingStoreConfig: ReportingStoreConfig,
    apiDeckApi: ApiDeckApiConfig,
    shipEngineApi: ShipEngineApiConfig,
    docuSignApi: DocuSignApiConfig,
    fronteggConfig: FronteggConfig,
    rawExportConfig: RawExportConfig,
    nodeServerHostname: string,
    internalApiSecret: string,
    devConfig: DevConfig,
    httpRateLimitDefault: number,
    httpRateLimitHighFrequent: number,
    apiDomainUrl: string,
    corsAllowedOrigins: string[],
    embeddedDashboardConfig?: (EmbeddedDashboardConfig|null),
  }
): ServerConfig {
  return {
    port: input.port,
    environment: input.environment,
    releaseName: input.releaseName,
    processorSecret: input.processorSecret,
    jwtSecret: input.jwtSecret,
    db: input.db,
    cronDb: input.cronDb,
    logging: input.logging,
    clientLogging: input.clientLogging === undefined ? null : input.clientLogging,
    threadPool: input.threadPool,
    flyway: input.flyway === undefined ? null : input.flyway,
    secretUrls: input.secretUrls,
    awsRegion: input.awsRegion,
    emailNotificationsConfig: input.emailNotificationsConfig,
    trueLayerApi: input.trueLayerApi,
    visionApis: input.visionApis,
    bloomberg: input.bloomberg,
    blobStoreConfig: input.blobStoreConfig,
    localBlobStoreConfig: input.localBlobStoreConfig,
    freightTransportApi: input.freightTransportApi,
    hotjarConfig: input.hotjarConfig,
    googleAnalyticsConfig: input.googleAnalyticsConfig,
    postHogConfig: input.postHogConfig,
    appBaseUrl: input.appBaseUrl,
    useLocalstack: input.useLocalstack === undefined ? false : input.useLocalstack,
    localstackHost: input.localstackHost === undefined ? "http://localstack:4566" : input.localstackHost,
    messageQueueConfig: input.messageQueueConfig,
    accountingServiceDomain: input.accountingServiceDomain,
    accountingApiUrl: input.accountingApiUrl,
    accountingApiKey: input.accountingApiKey,
    purchaseRequestTimelineDurations: input.purchaseRequestTimelineDurations,
    amsterdamWarehouseCompany: input.amsterdamWarehouseCompany,
    isReportingInstance: input.isReportingInstance,
    reportingStoreConfig: input.reportingStoreConfig,
    apiDeckApi: input.apiDeckApi,
    shipEngineApi: input.shipEngineApi,
    docuSignApi: input.docuSignApi,
    fronteggConfig: input.fronteggConfig,
    rawExportConfig: input.rawExportConfig,
    nodeServerHostname: input.nodeServerHostname,
    internalApiSecret: input.internalApiSecret,
    devConfig: input.devConfig,
    httpRateLimitDefault: input.httpRateLimitDefault,
    httpRateLimitHighFrequent: input.httpRateLimitHighFrequent,
    apiDomainUrl: input.apiDomainUrl,
    corsAllowedOrigins: input.corsAllowedOrigins,
    embeddedDashboardConfig: input.embeddedDashboardConfig === undefined ? null : input.embeddedDashboardConfig,
  };
}

const ServerConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Port to listen for requests\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"port","default":{"kind":"nothing"},"name":"port","typeExpr":{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}},{"annotations":[{"value":"Environment name, e.g. dev, uat, prod\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"environment","default":{"kind":"nothing"},"name":"environment","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Name of the release / code version\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"releaseName","default":{"kind":"nothing"},"name":"releaseName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The shared secret that will be present on requests from the queue\nprocessor system\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"processorSecret","default":{"kind":"nothing"},"name":"processorSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Secret used to sign JWT tokens\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"jwtSecret","default":{"kind":"nothing"},"name":"jwtSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Database config\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"db","default":{"kind":"nothing"},"name":"db","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.db","name":"PostgreSqlConfig"}},"parameters":[]}},{"annotations":[{"value":"Cron-specific configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"cronDb","default":{"kind":"nothing"},"name":"cronDb","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.db","name":"PostgreSqlConfig"}},"parameters":[]}},{"annotations":[{"value":"Server-side logging config\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"logging","default":{"kind":"nothing"},"name":"logging","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.log","name":"LogConfig"}},"parameters":[]}},{"annotations":[{"value":"Client-side logging config\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"clientLogging","default":{"kind":"just","value":null},"name":"clientLogging","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"ClientLogConfig"}},"parameters":[]}},{"annotations":[{"value":"Frontend threadpool configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"threadPool","default":{"kind":"nothing"},"name":"threadPool","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.frontend","name":"ThreadPoolConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"flyway","default":{"kind":"just","value":null},"name":"flyway","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.flyway","name":"FlywayConfig"}},"parameters":[]}]}},{"annotations":[],"serializedName":"secretUrls","default":{"kind":"nothing"},"name":"secretUrls","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"SecretUrls"}},"parameters":[]}},{"annotations":[],"serializedName":"awsRegion","default":{"kind":"nothing"},"name":"awsRegion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.aws","name":"AwsRegionProvider"}},"parameters":[]}},{"annotations":[],"serializedName":"emailNotificationsConfig","default":{"kind":"nothing"},"name":"emailNotificationsConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"EmailNotificationsConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"trueLayerApi","default":{"kind":"nothing"},"name":"trueLayerApi","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"TrueLayerApiConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"visionApis","default":{"kind":"nothing"},"name":"visionApis","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"VisionApiConfig"}},"parameters":[]}]}},{"annotations":[],"serializedName":"bloomberg","default":{"kind":"nothing"},"name":"bloomberg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"BloombergConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"blobStoreConfig","default":{"kind":"nothing"},"name":"blobStoreConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"BlobStoreConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"localBlobStoreConfig","default":{"kind":"nothing"},"name":"localBlobStoreConfig","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"LocalBlobStoreConfig"}},"parameters":[]}]}},{"annotations":[],"serializedName":"freightTransportApi","default":{"kind":"nothing"},"name":"freightTransportApi","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"FreightTransportApiConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"hotjarConfig","default":{"kind":"nothing"},"name":"hotjarConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"HotjarConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"googleAnalyticsConfig","default":{"kind":"nothing"},"name":"googleAnalyticsConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"GoogleAnalyticsConfig"}},"parameters":[]}},{"annotations":[{"value":"PostHog configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"postHogConfig","default":{"kind":"nothing"},"name":"postHogConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"PostHogConfig"}},"parameters":[]}},{"annotations":[{"value":"The app url for the current environment\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"appBaseUrl","default":{"kind":"nothing"},"name":"appBaseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"useLocalstack","default":{"kind":"just","value":false},"name":"useLocalstack","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"localstackHost","default":{"kind":"just","value":"http://localstack:4566"},"name":"localstackHost","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The queues that are used to broadcast messages to the Fero ecosystem and\nto receive feedback from the various services.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"messageQueueConfig","default":{"kind":"nothing"},"name":"messageQueueConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"MessageQueueConfig"}},"parameters":[]}},{"annotations":[{"value":"The domain of the accounting service to use\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"accountingServiceDomain","default":{"kind":"nothing"},"name":"accountingServiceDomain","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The base URL of the Accounting API\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"accountingApiUrl","default":{"kind":"nothing"},"name":"accountingApiUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"API key for the Accounting API\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"accountingApiKey","default":{"kind":"nothing"},"name":"accountingApiKey","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequestTimelineDurations","default":{"kind":"nothing"},"name":"purchaseRequestTimelineDurations","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"PurchaseRequestTimelineDurations"}},"parameters":[]}},{"annotations":[],"serializedName":"amsterdamWarehouseCompany","default":{"kind":"nothing"},"name":"amsterdamWarehouseCompany","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"AmsterdamWarehouseCompany"}},"parameters":[]}},{"annotations":[{"value":"Indicates whether the instance is a reporting instance\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"isReportingInstance","default":{"kind":"nothing"},"name":"isReportingInstance","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"reportingStoreConfig","default":{"kind":"nothing"},"name":"reportingStoreConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"ReportingStoreConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"apiDeckApi","default":{"kind":"nothing"},"name":"apiDeckApi","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"ApiDeckApiConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"shipEngineApi","default":{"kind":"nothing"},"name":"shipEngineApi","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"ShipEngineApiConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"docuSignApi","default":{"kind":"nothing"},"name":"docuSignApi","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"DocuSignApiConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"fronteggConfig","default":{"kind":"nothing"},"name":"fronteggConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"FronteggConfig"}},"parameters":[]}},{"annotations":[{"value":"Configuration for Raw Data extraction jobs\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"rawExportConfig","default":{"kind":"nothing"},"name":"rawExportConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"RawExportConfig"}},"parameters":[]}},{"annotations":[{"value":"The hostname of the node server. Value should be null if one should not be started\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"nodeServerHostname","default":{"kind":"nothing"},"name":"nodeServerHostname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Secret used to authenticate internal API calls between Java and Node appserver\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"internalApiSecret","default":{"kind":"nothing"},"name":"internalApiSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Leave this as the last entry please.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"devConfig","default":{"kind":"nothing"},"name":"devConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"DevConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"httpRateLimitDefault","default":{"kind":"nothing"},"name":"httpRateLimitDefault","typeExpr":{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}},{"annotations":[],"serializedName":"httpRateLimitHighFrequent","default":{"kind":"nothing"},"name":"httpRateLimitHighFrequent","typeExpr":{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}},{"annotations":[{"value":"The domain of the API eg. https://api.fero.capital\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"apiDomainUrl","default":{"kind":"nothing"},"name":"apiDomainUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"corsAllowedOrigins","default":{"kind":"nothing"},"name":"corsAllowedOrigins","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"value":"Embedded dashboard configuration (optional - only needed if using embedded dashboards)\nConfigure providers in the list (mock for local dev, quicksight for production)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"embeddedDashboardConfig","default":{"kind":"just","value":null},"name":"embeddedDashboardConfig","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"EmbeddedDashboardConfig"}},"parameters":[]}]}}]}},"name":"ServerConfig","version":{"kind":"nothing"}}};

export const snServerConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"ServerConfig"};

export function texprServerConfig(): ADL.ATypeExpr<ServerConfig> {
  return {value : {typeRef : {kind: "reference", value : snServerConfig}, parameters : []}};
}

export interface DevConfig {
  logJavlin: boolean;
  blobStoreConfig: (BlobStoreConfig|null);
  localSimulatedS3Config: (S3BlobStoreConfig|null);
}

export function makeDevConfig(
  input: {
    logJavlin?: boolean,
    blobStoreConfig: (BlobStoreConfig|null),
    localSimulatedS3Config: (S3BlobStoreConfig|null),
  }
): DevConfig {
  return {
    logJavlin: input.logJavlin === undefined ? true : input.logJavlin,
    blobStoreConfig: input.blobStoreConfig,
    localSimulatedS3Config: input.localSimulatedS3Config,
  };
}

const DevConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"logJavlin","default":{"kind":"just","value":true},"name":"logJavlin","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"blobStoreConfig","default":{"kind":"nothing"},"name":"blobStoreConfig","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"BlobStoreConfig"}},"parameters":[]}]}},{"annotations":[],"serializedName":"localSimulatedS3Config","default":{"kind":"nothing"},"name":"localSimulatedS3Config","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"S3BlobStoreConfig"}},"parameters":[]}]}}]}},"name":"DevConfig","version":{"kind":"nothing"}}};

export const snDevConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"DevConfig"};

export function texprDevConfig(): ADL.ATypeExpr<DevConfig> {
  return {value : {typeRef : {kind: "reference", value : snDevConfig}, parameters : []}};
}

export interface MessageQueueConfig {
  saleOrdersQueue: string;
  saleOrdersFeedbackQueue: string;
  negativeStockAdjustmentQueue: string;
  negativeStockAdjustmentFeedbackQueue: string;
  newStockProcurementFeedbackDepositInvoicedQueue: string;
  existingStockProcurementQueue: string;
  newDealRequestLossesQueue: string;
  newDealRequestLossesFeedbackQueue: string;
  voidNewDealInvoiceQueue: string;
  voidNewDealInvoiceFeedbackQueue: string;
  newStockProcurementQueue: string;
  dealRollsQueue: string;
  dealRollsFeedbackQueue: string;
  supplierIsPaidQueue: string;
  thirdPartySalesQueue: string;
  thirdPartySalesFeedbackQueue: string;
  extendedPayloadS3BucketName: string;
  newStockProcurementFeedbackPurchaseBillCreatedQueue: string;
  thirdPartySalesAdvanceUponDeliveryIsPaidSqsQueue: string;
  docuSignConnectQueue: string;
  lawPurchaseRequestReadyForCollectionQueue: string;
  lawPurchaseRequestCancellationQueue: string;
  purchaseRequestCsvReportQueue: string;
}

export function makeMessageQueueConfig(
  input: {
    saleOrdersQueue: string,
    saleOrdersFeedbackQueue: string,
    negativeStockAdjustmentQueue: string,
    negativeStockAdjustmentFeedbackQueue: string,
    newStockProcurementFeedbackDepositInvoicedQueue: string,
    existingStockProcurementQueue: string,
    newDealRequestLossesQueue: string,
    newDealRequestLossesFeedbackQueue: string,
    voidNewDealInvoiceQueue: string,
    voidNewDealInvoiceFeedbackQueue: string,
    newStockProcurementQueue: string,
    dealRollsQueue: string,
    dealRollsFeedbackQueue: string,
    supplierIsPaidQueue: string,
    thirdPartySalesQueue: string,
    thirdPartySalesFeedbackQueue: string,
    extendedPayloadS3BucketName: string,
    newStockProcurementFeedbackPurchaseBillCreatedQueue: string,
    thirdPartySalesAdvanceUponDeliveryIsPaidSqsQueue: string,
    docuSignConnectQueue: string,
    lawPurchaseRequestReadyForCollectionQueue: string,
    lawPurchaseRequestCancellationQueue: string,
    purchaseRequestCsvReportQueue: string,
  }
): MessageQueueConfig {
  return {
    saleOrdersQueue: input.saleOrdersQueue,
    saleOrdersFeedbackQueue: input.saleOrdersFeedbackQueue,
    negativeStockAdjustmentQueue: input.negativeStockAdjustmentQueue,
    negativeStockAdjustmentFeedbackQueue: input.negativeStockAdjustmentFeedbackQueue,
    newStockProcurementFeedbackDepositInvoicedQueue: input.newStockProcurementFeedbackDepositInvoicedQueue,
    existingStockProcurementQueue: input.existingStockProcurementQueue,
    newDealRequestLossesQueue: input.newDealRequestLossesQueue,
    newDealRequestLossesFeedbackQueue: input.newDealRequestLossesFeedbackQueue,
    voidNewDealInvoiceQueue: input.voidNewDealInvoiceQueue,
    voidNewDealInvoiceFeedbackQueue: input.voidNewDealInvoiceFeedbackQueue,
    newStockProcurementQueue: input.newStockProcurementQueue,
    dealRollsQueue: input.dealRollsQueue,
    dealRollsFeedbackQueue: input.dealRollsFeedbackQueue,
    supplierIsPaidQueue: input.supplierIsPaidQueue,
    thirdPartySalesQueue: input.thirdPartySalesQueue,
    thirdPartySalesFeedbackQueue: input.thirdPartySalesFeedbackQueue,
    extendedPayloadS3BucketName: input.extendedPayloadS3BucketName,
    newStockProcurementFeedbackPurchaseBillCreatedQueue: input.newStockProcurementFeedbackPurchaseBillCreatedQueue,
    thirdPartySalesAdvanceUponDeliveryIsPaidSqsQueue: input.thirdPartySalesAdvanceUponDeliveryIsPaidSqsQueue,
    docuSignConnectQueue: input.docuSignConnectQueue,
    lawPurchaseRequestReadyForCollectionQueue: input.lawPurchaseRequestReadyForCollectionQueue,
    lawPurchaseRequestCancellationQueue: input.lawPurchaseRequestCancellationQueue,
    purchaseRequestCsvReportQueue: input.purchaseRequestCsvReportQueue,
  };
}

const MessageQueueConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"saleOrdersQueue","default":{"kind":"nothing"},"name":"saleOrdersQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"saleOrdersFeedbackQueue","default":{"kind":"nothing"},"name":"saleOrdersFeedbackQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"negativeStockAdjustmentQueue","default":{"kind":"nothing"},"name":"negativeStockAdjustmentQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"negativeStockAdjustmentFeedbackQueue","default":{"kind":"nothing"},"name":"negativeStockAdjustmentFeedbackQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"newStockProcurementFeedbackDepositInvoicedQueue","default":{"kind":"nothing"},"name":"newStockProcurementFeedbackDepositInvoicedQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"existingStockProcurementQueue","default":{"kind":"nothing"},"name":"existingStockProcurementQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"newDealRequestLossesQueue","default":{"kind":"nothing"},"name":"newDealRequestLossesQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"newDealRequestLossesFeedbackQueue","default":{"kind":"nothing"},"name":"newDealRequestLossesFeedbackQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"voidNewDealInvoiceQueue","default":{"kind":"nothing"},"name":"voidNewDealInvoiceQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"voidNewDealInvoiceFeedbackQueue","default":{"kind":"nothing"},"name":"voidNewDealInvoiceFeedbackQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"newStockProcurementQueue","default":{"kind":"nothing"},"name":"newStockProcurementQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"dealRollsQueue","default":{"kind":"nothing"},"name":"dealRollsQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"dealRollsFeedbackQueue","default":{"kind":"nothing"},"name":"dealRollsFeedbackQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"supplierIsPaidQueue","default":{"kind":"nothing"},"name":"supplierIsPaidQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"thirdPartySalesQueue","default":{"kind":"nothing"},"name":"thirdPartySalesQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"thirdPartySalesFeedbackQueue","default":{"kind":"nothing"},"name":"thirdPartySalesFeedbackQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"extendedPayloadS3BucketName","default":{"kind":"nothing"},"name":"extendedPayloadS3BucketName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"newStockProcurementFeedbackPurchaseBillCreatedQueue","default":{"kind":"nothing"},"name":"newStockProcurementFeedbackPurchaseBillCreatedQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"thirdPartySalesAdvanceUponDeliveryIsPaidSqsQueue","default":{"kind":"nothing"},"name":"thirdPartySalesAdvanceUponDeliveryIsPaidSqsQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"docuSignConnectQueue","default":{"kind":"nothing"},"name":"docuSignConnectQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"lawPurchaseRequestReadyForCollectionQueue","default":{"kind":"nothing"},"name":"lawPurchaseRequestReadyForCollectionQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"lawPurchaseRequestCancellationQueue","default":{"kind":"nothing"},"name":"lawPurchaseRequestCancellationQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequestCsvReportQueue","default":{"kind":"nothing"},"name":"purchaseRequestCsvReportQueue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"MessageQueueConfig","version":{"kind":"nothing"}}};

export const snMessageQueueConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"MessageQueueConfig"};

export function texprMessageQueueConfig(): ADL.ATypeExpr<MessageQueueConfig> {
  return {value : {typeRef : {kind: "reference", value : snMessageQueueConfig}, parameters : []}};
}

export type ClientLogConfig = (common_config_log.FluentdConfig|null);

const ClientLogConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.log","name":"FluentdConfig"}},"parameters":[]}]}}},"name":"ClientLogConfig","version":{"kind":"nothing"}}};

export const snClientLogConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"ClientLogConfig"};

export function texprClientLogConfig(): ADL.ATypeExpr<ClientLogConfig> {
  return {value : {typeRef : {kind: "reference", value : snClientLogConfig}, parameters : []}};
}

export interface OAuthConfig {
  clientId: string;
  clientSecret: string;
  tokenServerUrl: string;
  authorisationServerUrl: (string|null);
  redirectUri: (string|null);
}

export function makeOAuthConfig(
  input: {
    clientId: string,
    clientSecret: string,
    tokenServerUrl: string,
    authorisationServerUrl?: (string|null),
    redirectUri?: (string|null),
  }
): OAuthConfig {
  return {
    clientId: input.clientId,
    clientSecret: input.clientSecret,
    tokenServerUrl: input.tokenServerUrl,
    authorisationServerUrl: input.authorisationServerUrl === undefined ? null : input.authorisationServerUrl,
    redirectUri: input.redirectUri === undefined ? null : input.redirectUri,
  };
}

const OAuthConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"clientId","default":{"kind":"nothing"},"name":"clientId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"clientSecret","default":{"kind":"nothing"},"name":"clientSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"tokenServerUrl","default":{"kind":"nothing"},"name":"tokenServerUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"authorisationServerUrl","default":{"kind":"just","value":null},"name":"authorisationServerUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"redirectUri","default":{"kind":"just","value":null},"name":"redirectUri","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"OAuthConfig","version":{"kind":"nothing"}}};

export const snOAuthConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"OAuthConfig"};

export function texprOAuthConfig(): ADL.ATypeExpr<OAuthConfig> {
  return {value : {typeRef : {kind: "reference", value : snOAuthConfig}, parameters : []}};
}

/**
 * SMTP server configuration
 */
export interface SmtpConfig {
  host: string;
  port: number;
  auth: boolean;
  connectionTimeoutMs: number;
  timeoutMs: number;
}

export function makeSmtpConfig(
  input: {
    host: string,
    port?: number,
    auth?: boolean,
    connectionTimeoutMs?: number,
    timeoutMs?: number,
  }
): SmtpConfig {
  return {
    host: input.host,
    port: input.port === undefined ? 25 : input.port,
    auth: input.auth === undefined ? false : input.auth,
    connectionTimeoutMs: input.connectionTimeoutMs === undefined ? 5000 : input.connectionTimeoutMs,
    timeoutMs: input.timeoutMs === undefined ? 5000 : input.timeoutMs,
  };
}

const SmtpConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[{"value":"SMTP server configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"host","default":{"kind":"nothing"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"port","default":{"kind":"just","value":25},"name":"port","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"auth","default":{"kind":"just","value":false},"name":"auth","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"connectionTimeoutMs","default":{"kind":"just","value":5000},"name":"connectionTimeoutMs","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"timeoutMs","default":{"kind":"just","value":5000},"name":"timeoutMs","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"SmtpConfig","version":{"kind":"nothing"}}};

export const snSmtpConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"SmtpConfig"};

export function texprSmtpConfig(): ADL.ATypeExpr<SmtpConfig> {
  return {value : {typeRef : {kind: "reference", value : snSmtpConfig}, parameters : []}};
}

export interface EmailTransportConfig_Log {
  kind: 'log';
}
export interface EmailTransportConfig_Ses {
  kind: 'ses';
}
export interface EmailTransportConfig_Smtp {
  kind: 'smtp';
  value: SmtpConfig;
}

/**
 * Email transport configuration
 */
export type EmailTransportConfig = EmailTransportConfig_Log | EmailTransportConfig_Ses | EmailTransportConfig_Smtp;

export interface EmailTransportConfigOpts {
  /**
   * Log email details without sending
   */
  log: null;
  /**
   * Send via AWS SES
   */
  ses: null;
  /**
   * Send via SMTP server
   */
  smtp: SmtpConfig;
}

export function makeEmailTransportConfig<K extends keyof EmailTransportConfigOpts>(kind: K, value: EmailTransportConfigOpts[K]) { return {kind, value}; }

const EmailTransportConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[{"value":"Email transport configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Log email details without sending\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"log","default":{"kind":"nothing"},"name":"log","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"value":"Send via AWS SES\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"ses","default":{"kind":"nothing"},"name":"ses","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"value":"Send via SMTP server\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"smtp","default":{"kind":"nothing"},"name":"smtp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"SmtpConfig"}},"parameters":[]}}]}},"name":"EmailTransportConfig","version":{"kind":"nothing"}}};

export const snEmailTransportConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"EmailTransportConfig"};

export function texprEmailTransportConfig(): ADL.ATypeExpr<EmailTransportConfig> {
  return {value : {typeRef : {kind: "reference", value : snEmailTransportConfig}, parameters : []}};
}

export interface EmailNotificationsConfig {
  transport: EmailTransportConfig;
  fromEmail: common_strings.EmailAddress;
  accountingFromEmail: common_strings.EmailAddress;
  toEmail: common_strings.EmailAddress;
  replyToEmail: common_strings.EmailAddress;
}

export function makeEmailNotificationsConfig(
  input: {
    transport: EmailTransportConfig,
    fromEmail: common_strings.EmailAddress,
    accountingFromEmail: common_strings.EmailAddress,
    toEmail: common_strings.EmailAddress,
    replyToEmail: common_strings.EmailAddress,
  }
): EmailNotificationsConfig {
  return {
    transport: input.transport,
    fromEmail: input.fromEmail,
    accountingFromEmail: input.accountingFromEmail,
    toEmail: input.toEmail,
    replyToEmail: input.replyToEmail,
  };
}

const EmailNotificationsConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"transport","default":{"kind":"nothing"},"name":"transport","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"EmailTransportConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"fromEmail","default":{"kind":"nothing"},"name":"fromEmail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}},{"annotations":[],"serializedName":"accountingFromEmail","default":{"kind":"nothing"},"name":"accountingFromEmail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}},{"annotations":[],"serializedName":"toEmail","default":{"kind":"nothing"},"name":"toEmail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}},{"annotations":[],"serializedName":"replyToEmail","default":{"kind":"nothing"},"name":"replyToEmail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}}]}},"name":"EmailNotificationsConfig","version":{"kind":"nothing"}}};

export const snEmailNotificationsConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"EmailNotificationsConfig"};

export function texprEmailNotificationsConfig(): ADL.ATypeExpr<EmailNotificationsConfig> {
  return {value : {typeRef : {kind: "reference", value : snEmailNotificationsConfig}, parameters : []}};
}

export interface SecretUrls {
  prefix: string;
  viewPurchasedStock: string;
  viewPurchasedStockCSV: string;
  viewSoldStock: string;
  viewSoldStockCSV: string;
  viewCapitalisedExpenses: string;
  viewCapitalisedExpensesCSV: string;
}

export function makeSecretUrls(
  input: {
    prefix: string,
    viewPurchasedStock?: string,
    viewPurchasedStockCSV?: string,
    viewSoldStock?: string,
    viewSoldStockCSV?: string,
    viewCapitalisedExpenses?: string,
    viewCapitalisedExpensesCSV?: string,
  }
): SecretUrls {
  return {
    prefix: input.prefix,
    viewPurchasedStock: input.viewPurchasedStock === undefined ? "viewPurchasedStock" : input.viewPurchasedStock,
    viewPurchasedStockCSV: input.viewPurchasedStockCSV === undefined ? "viewPurchasedStockCSV" : input.viewPurchasedStockCSV,
    viewSoldStock: input.viewSoldStock === undefined ? "viewSoldStock" : input.viewSoldStock,
    viewSoldStockCSV: input.viewSoldStockCSV === undefined ? "viewSoldStockCSV" : input.viewSoldStockCSV,
    viewCapitalisedExpenses: input.viewCapitalisedExpenses === undefined ? "viewCapitalisedExpenses" : input.viewCapitalisedExpenses,
    viewCapitalisedExpensesCSV: input.viewCapitalisedExpensesCSV === undefined ? "viewCapitalisedExpensesCSV" : input.viewCapitalisedExpensesCSV,
  };
}

const SecretUrls_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"prefix","default":{"kind":"nothing"},"name":"prefix","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"viewPurchasedStock","default":{"kind":"just","value":"viewPurchasedStock"},"name":"viewPurchasedStock","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"viewPurchasedStockCSV","default":{"kind":"just","value":"viewPurchasedStockCSV"},"name":"viewPurchasedStockCSV","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"viewSoldStock","default":{"kind":"just","value":"viewSoldStock"},"name":"viewSoldStock","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"viewSoldStockCSV","default":{"kind":"just","value":"viewSoldStockCSV"},"name":"viewSoldStockCSV","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"viewCapitalisedExpenses","default":{"kind":"just","value":"viewCapitalisedExpenses"},"name":"viewCapitalisedExpenses","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"viewCapitalisedExpensesCSV","default":{"kind":"just","value":"viewCapitalisedExpensesCSV"},"name":"viewCapitalisedExpensesCSV","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"SecretUrls","version":{"kind":"nothing"}}};

export const snSecretUrls: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"SecretUrls"};

export function texprSecretUrls(): ADL.ATypeExpr<SecretUrls> {
  return {value : {typeRef : {kind: "reference", value : snSecretUrls}, parameters : []}};
}

export interface VisionApiConfig {
  baseUrl: string;
  name: string;
  oAuth: OAuthConfig;
}

export function makeVisionApiConfig(
  input: {
    baseUrl: string,
    name: string,
    oAuth: OAuthConfig,
  }
): VisionApiConfig {
  return {
    baseUrl: input.baseUrl,
    name: input.name,
    oAuth: input.oAuth,
  };
}

const VisionApiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"baseUrl","default":{"kind":"nothing"},"name":"baseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"oAuth","default":{"kind":"nothing"},"name":"oAuth","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"OAuthConfig"}},"parameters":[]}}]}},"name":"VisionApiConfig","version":{"kind":"nothing"}}};

export const snVisionApiConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"VisionApiConfig"};

export function texprVisionApiConfig(): ADL.ATypeExpr<VisionApiConfig> {
  return {value : {typeRef : {kind: "reference", value : snVisionApiConfig}, parameters : []}};
}

export interface BloombergApiConfig {
  baseUrl: string;
  enabled: boolean;
  name: string;
  catalog: string;
  oAuth: OAuthConfig;
}

export function makeBloombergApiConfig(
  input: {
    baseUrl: string,
    enabled: boolean,
    name: string,
    catalog: string,
    oAuth: OAuthConfig,
  }
): BloombergApiConfig {
  return {
    baseUrl: input.baseUrl,
    enabled: input.enabled,
    name: input.name,
    catalog: input.catalog,
    oAuth: input.oAuth,
  };
}

const BloombergApiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"baseUrl","default":{"kind":"nothing"},"name":"baseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"enabled","default":{"kind":"nothing"},"name":"enabled","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"catalog","default":{"kind":"nothing"},"name":"catalog","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"oAuth","default":{"kind":"nothing"},"name":"oAuth","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"OAuthConfig"}},"parameters":[]}}]}},"name":"BloombergApiConfig","version":{"kind":"nothing"}}};

export const snBloombergApiConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"BloombergApiConfig"};

export function texprBloombergApiConfig(): ADL.ATypeExpr<BloombergApiConfig> {
  return {value : {typeRef : {kind: "reference", value : snBloombergApiConfig}, parameters : []}};
}

export interface BloombergRequests {
  dailyRateRequestId: string;
}

export function makeBloombergRequests(
  input: {
    dailyRateRequestId: string,
  }
): BloombergRequests {
  return {
    dailyRateRequestId: input.dailyRateRequestId,
  };
}

const BloombergRequests_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"dailyRateRequestId","default":{"kind":"nothing"},"name":"dailyRateRequestId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"BloombergRequests","version":{"kind":"nothing"}}};

export const snBloombergRequests: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"BloombergRequests"};

export function texprBloombergRequests(): ADL.ATypeExpr<BloombergRequests> {
  return {value : {typeRef : {kind: "reference", value : snBloombergRequests}, parameters : []}};
}

export interface BloombergConfig {
  api: BloombergApiConfig;
  requests: BloombergRequests;
}

export function makeBloombergConfig(
  input: {
    api: BloombergApiConfig,
    requests: BloombergRequests,
  }
): BloombergConfig {
  return {
    api: input.api,
    requests: input.requests,
  };
}

const BloombergConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"api","default":{"kind":"nothing"},"name":"api","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"BloombergApiConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"requests","default":{"kind":"nothing"},"name":"requests","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"BloombergRequests"}},"parameters":[]}}]}},"name":"BloombergConfig","version":{"kind":"nothing"}}};

export const snBloombergConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"BloombergConfig"};

export function texprBloombergConfig(): ADL.ATypeExpr<BloombergConfig> {
  return {value : {typeRef : {kind: "reference", value : snBloombergConfig}, parameters : []}};
}

export interface TrueLayerApiConfig {
  baseUrl: string;
  oAuth: OAuthConfig;
}

export function makeTrueLayerApiConfig(
  input: {
    baseUrl: string,
    oAuth: OAuthConfig,
  }
): TrueLayerApiConfig {
  return {
    baseUrl: input.baseUrl,
    oAuth: input.oAuth,
  };
}

const TrueLayerApiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"baseUrl","default":{"kind":"nothing"},"name":"baseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"oAuth","default":{"kind":"nothing"},"name":"oAuth","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"OAuthConfig"}},"parameters":[]}}]}},"name":"TrueLayerApiConfig","version":{"kind":"nothing"}}};

export const snTrueLayerApiConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"TrueLayerApiConfig"};

export function texprTrueLayerApiConfig(): ADL.ATypeExpr<TrueLayerApiConfig> {
  return {value : {typeRef : {kind: "reference", value : snTrueLayerApiConfig}, parameters : []}};
}

export interface BlobStoreConfig_S3 {
  kind: 's3';
  value: S3BlobStoreConfig;
}
export interface BlobStoreConfig_Localstack {
  kind: 'localstack';
  value: S3BlobStoreConfig;
}
export interface BlobStoreConfig_Local {
  kind: 'local';
  value: S3LocalBlobStoreConfig;
}

export type BlobStoreConfig = BlobStoreConfig_S3 | BlobStoreConfig_Localstack | BlobStoreConfig_Local;

export interface BlobStoreConfigOpts {
  s3: S3BlobStoreConfig;
  localstack: S3BlobStoreConfig;
  local: S3LocalBlobStoreConfig;
}

export function makeBlobStoreConfig<K extends keyof BlobStoreConfigOpts>(kind: K, value: BlobStoreConfigOpts[K]) { return {kind, value}; }

const BlobStoreConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"s3","default":{"kind":"nothing"},"name":"s3","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"S3BlobStoreConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"localstack","default":{"kind":"nothing"},"name":"localstack","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"S3BlobStoreConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"local","default":{"kind":"nothing"},"name":"local","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"S3LocalBlobStoreConfig"}},"parameters":[]}}]}},"name":"BlobStoreConfig","version":{"kind":"nothing"}}};

export const snBlobStoreConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"BlobStoreConfig"};

export function texprBlobStoreConfig(): ADL.ATypeExpr<BlobStoreConfig> {
  return {value : {typeRef : {kind: "reference", value : snBlobStoreConfig}, parameters : []}};
}

export interface S3LocalBlobStoreConfig {
  filePath: string;
  simulatedS3Config: S3BlobStoreConfig;
}

export function makeS3LocalBlobStoreConfig(
  input: {
    filePath: string,
    simulatedS3Config: S3BlobStoreConfig,
  }
): S3LocalBlobStoreConfig {
  return {
    filePath: input.filePath,
    simulatedS3Config: input.simulatedS3Config,
  };
}

const S3LocalBlobStoreConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"simulatedS3Config","default":{"kind":"nothing"},"name":"simulatedS3Config","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"S3BlobStoreConfig"}},"parameters":[]}}]}},"name":"S3LocalBlobStoreConfig","version":{"kind":"nothing"}}};

export const snS3LocalBlobStoreConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"S3LocalBlobStoreConfig"};

export function texprS3LocalBlobStoreConfig(): ADL.ATypeExpr<S3LocalBlobStoreConfig> {
  return {value : {typeRef : {kind: "reference", value : snS3LocalBlobStoreConfig}, parameters : []}};
}

export interface LocalBlobStoreConfig {
  filePath: string;
}

export function makeLocalBlobStoreConfig(
  input: {
    filePath: string,
  }
): LocalBlobStoreConfig {
  return {
    filePath: input.filePath,
  };
}

const LocalBlobStoreConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"LocalBlobStoreConfig","version":{"kind":"nothing"}}};

export const snLocalBlobStoreConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"LocalBlobStoreConfig"};

export function texprLocalBlobStoreConfig(): ADL.ATypeExpr<LocalBlobStoreConfig> {
  return {value : {typeRef : {kind: "reference", value : snLocalBlobStoreConfig}, parameters : []}};
}

export interface S3BlobStoreConfig {
  assetLocation: common_config_aws.S3Location;
  documentLocation: common_config_aws.S3Location;
  dataLocation: common_config_aws.S3Location;
}

export function makeS3BlobStoreConfig(
  input: {
    assetLocation: common_config_aws.S3Location,
    documentLocation: common_config_aws.S3Location,
    dataLocation: common_config_aws.S3Location,
  }
): S3BlobStoreConfig {
  return {
    assetLocation: input.assetLocation,
    documentLocation: input.documentLocation,
    dataLocation: input.dataLocation,
  };
}

const S3BlobStoreConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"assetLocation","default":{"kind":"nothing"},"name":"assetLocation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.aws","name":"S3Location"}},"parameters":[]}},{"annotations":[],"serializedName":"documentLocation","default":{"kind":"nothing"},"name":"documentLocation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.aws","name":"S3Location"}},"parameters":[]}},{"annotations":[],"serializedName":"dataLocation","default":{"kind":"nothing"},"name":"dataLocation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.aws","name":"S3Location"}},"parameters":[]}}]}},"name":"S3BlobStoreConfig","version":{"kind":"nothing"}}};

export const snS3BlobStoreConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"S3BlobStoreConfig"};

export function texprS3BlobStoreConfig(): ADL.ATypeExpr<S3BlobStoreConfig> {
  return {value : {typeRef : {kind: "reference", value : snS3BlobStoreConfig}, parameters : []}};
}

export interface HotjarConfig {
  siteId: string;
  version: string;
}

export function makeHotjarConfig(
  input: {
    siteId: string,
    version: string,
  }
): HotjarConfig {
  return {
    siteId: input.siteId,
    version: input.version,
  };
}

const HotjarConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"siteId","default":{"kind":"nothing"},"name":"siteId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"HotjarConfig","version":{"kind":"nothing"}}};

export const snHotjarConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"HotjarConfig"};

export function texprHotjarConfig(): ADL.ATypeExpr<HotjarConfig> {
  return {value : {typeRef : {kind: "reference", value : snHotjarConfig}, parameters : []}};
}

/**
 * Google Analytics configuration
 */
export interface GoogleAnalyticsConfig {
  measurementId: string;
}

export function makeGoogleAnalyticsConfig(
  input: {
    measurementId: string,
  }
): GoogleAnalyticsConfig {
  return {
    measurementId: input.measurementId,
  };
}

const GoogleAnalyticsConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[{"value":"Google Analytics configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"measurementId","default":{"kind":"nothing"},"name":"measurementId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"GoogleAnalyticsConfig","version":{"kind":"nothing"}}};

export const snGoogleAnalyticsConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"GoogleAnalyticsConfig"};

export function texprGoogleAnalyticsConfig(): ADL.ATypeExpr<GoogleAnalyticsConfig> {
  return {value : {typeRef : {kind: "reference", value : snGoogleAnalyticsConfig}, parameters : []}};
}

export interface PostHogConfig {
  projectId: string;
  /**
   * Public API key for the PostHog instance
   */
  publicApiKey: string;
  host: string;
  /**
   * Private key used for "local evaluation" https://posthog.com/docs/feature-flags/local-evaluation
   */
  featureFlagsSecureKey: string;
}

export function makePostHogConfig(
  input: {
    projectId: string,
    publicApiKey: string,
    host?: string,
    featureFlagsSecureKey: string,
  }
): PostHogConfig {
  return {
    projectId: input.projectId,
    publicApiKey: input.publicApiKey,
    host: input.host === undefined ? "https://eu.i.posthog.com" : input.host,
    featureFlagsSecureKey: input.featureFlagsSecureKey,
  };
}

const PostHogConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"projectId","default":{"kind":"nothing"},"name":"projectId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Public API key for the PostHog instance\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"publicApiKey","default":{"kind":"nothing"},"name":"publicApiKey","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"host","default":{"kind":"just","value":"https://eu.i.posthog.com"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Private key used for \"local evaluation\" https://posthog.com/docs/feature-flags/local-evaluation\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"featureFlagsSecureKey","default":{"kind":"nothing"},"name":"featureFlagsSecureKey","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"PostHogConfig","version":{"kind":"nothing"}}};

export const snPostHogConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"PostHogConfig"};

export function texprPostHogConfig(): ADL.ATypeExpr<PostHogConfig> {
  return {value : {typeRef : {kind: "reference", value : snPostHogConfig}, parameters : []}};
}

export interface PurchaseRequestTimelineDurations {
  maxCollectionDays: number;
}

export function makePurchaseRequestTimelineDurations(
  input: {
    maxCollectionDays?: number,
  }
): PurchaseRequestTimelineDurations {
  return {
    maxCollectionDays: input.maxCollectionDays === undefined ? 14 : input.maxCollectionDays,
  };
}

const PurchaseRequestTimelineDurations_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"maxCollectionDays","default":{"kind":"just","value":14},"name":"maxCollectionDays","typeExpr":{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}}]}},"name":"PurchaseRequestTimelineDurations","version":{"kind":"nothing"}}};

export const snPurchaseRequestTimelineDurations: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"PurchaseRequestTimelineDurations"};

export function texprPurchaseRequestTimelineDurations(): ADL.ATypeExpr<PurchaseRequestTimelineDurations> {
  return {value : {typeRef : {kind: "reference", value : snPurchaseRequestTimelineDurations}, parameters : []}};
}

export interface AmsterdamWarehouseCompany {
  saleOrderEmail: string;
  feroContactEmail: string;
  feroContactNumber: string;
}

export function makeAmsterdamWarehouseCompany(
  input: {
    saleOrderEmail: string,
    feroContactEmail: string,
    feroContactNumber: string,
  }
): AmsterdamWarehouseCompany {
  return {
    saleOrderEmail: input.saleOrderEmail,
    feroContactEmail: input.feroContactEmail,
    feroContactNumber: input.feroContactNumber,
  };
}

const AmsterdamWarehouseCompany_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"saleOrderEmail","default":{"kind":"nothing"},"name":"saleOrderEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"feroContactEmail","default":{"kind":"nothing"},"name":"feroContactEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"feroContactNumber","default":{"kind":"nothing"},"name":"feroContactNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"AmsterdamWarehouseCompany","version":{"kind":"nothing"}}};

export const snAmsterdamWarehouseCompany: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"AmsterdamWarehouseCompany"};

export function texprAmsterdamWarehouseCompany(): ADL.ATypeExpr<AmsterdamWarehouseCompany> {
  return {value : {typeRef : {kind: "reference", value : snAmsterdamWarehouseCompany}, parameters : []}};
}

export interface ReportingStoreConfig_Local {
  kind: 'local';
  value: string;
}
export interface ReportingStoreConfig_S3 {
  kind: 's3';
  value: common_config_aws.S3Location;
}

export type ReportingStoreConfig = ReportingStoreConfig_Local | ReportingStoreConfig_S3;

export interface ReportingStoreConfigOpts {
  local: string;
  s3: common_config_aws.S3Location;
}

export function makeReportingStoreConfig<K extends keyof ReportingStoreConfigOpts>(kind: K, value: ReportingStoreConfigOpts[K]) { return {kind, value}; }

const ReportingStoreConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"local","default":{"kind":"nothing"},"name":"local","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"s3","default":{"kind":"nothing"},"name":"s3","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.aws","name":"S3Location"}},"parameters":[]}}]}},"name":"ReportingStoreConfig","version":{"kind":"nothing"}}};

export const snReportingStoreConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"ReportingStoreConfig"};

export function texprReportingStoreConfig(): ADL.ATypeExpr<ReportingStoreConfig> {
  return {value : {typeRef : {kind: "reference", value : snReportingStoreConfig}, parameters : []}};
}

export interface ApiDeckApiConfig {
  baseUrl: string;
  apiKey: string;
  appId: string;
}

export function makeApiDeckApiConfig(
  input: {
    baseUrl: string,
    apiKey: string,
    appId: string,
  }
): ApiDeckApiConfig {
  return {
    baseUrl: input.baseUrl,
    apiKey: input.apiKey,
    appId: input.appId,
  };
}

const ApiDeckApiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"baseUrl","default":{"kind":"nothing"},"name":"baseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"apiKey","default":{"kind":"nothing"},"name":"apiKey","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"appId","default":{"kind":"nothing"},"name":"appId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ApiDeckApiConfig","version":{"kind":"nothing"}}};

export const snApiDeckApiConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"ApiDeckApiConfig"};

export function texprApiDeckApiConfig(): ADL.ATypeExpr<ApiDeckApiConfig> {
  return {value : {typeRef : {kind: "reference", value : snApiDeckApiConfig}, parameters : []}};
}

export interface FreightTransportApiConfig {
  baseUrl: string;
  apiKey: string;
  ftlCarrierId: string;
}

export function makeFreightTransportApiConfig(
  input: {
    baseUrl: string,
    apiKey: string,
    ftlCarrierId: string,
  }
): FreightTransportApiConfig {
  return {
    baseUrl: input.baseUrl,
    apiKey: input.apiKey,
    ftlCarrierId: input.ftlCarrierId,
  };
}

const FreightTransportApiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"baseUrl","default":{"kind":"nothing"},"name":"baseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"apiKey","default":{"kind":"nothing"},"name":"apiKey","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"ftlCarrierId","default":{"kind":"nothing"},"name":"ftlCarrierId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"FreightTransportApiConfig","version":{"kind":"nothing"}}};

export const snFreightTransportApiConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"FreightTransportApiConfig"};

export function texprFreightTransportApiConfig(): ADL.ATypeExpr<FreightTransportApiConfig> {
  return {value : {typeRef : {kind: "reference", value : snFreightTransportApiConfig}, parameters : []}};
}

export interface ShipEngineApiConfig {
  baseUrl: string;
  apiKey: string;
}

export function makeShipEngineApiConfig(
  input: {
    baseUrl: string,
    apiKey: string,
  }
): ShipEngineApiConfig {
  return {
    baseUrl: input.baseUrl,
    apiKey: input.apiKey,
  };
}

const ShipEngineApiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"baseUrl","default":{"kind":"nothing"},"name":"baseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"apiKey","default":{"kind":"nothing"},"name":"apiKey","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ShipEngineApiConfig","version":{"kind":"nothing"}}};

export const snShipEngineApiConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"ShipEngineApiConfig"};

export function texprShipEngineApiConfig(): ADL.ATypeExpr<ShipEngineApiConfig> {
  return {value : {typeRef : {kind: "reference", value : snShipEngineApiConfig}, parameters : []}};
}

export interface DocuSignApiConfig {
  baseUrl: string;
  rsaPrivateKey: string;
  userId: string;
  oAuth: OAuthConfig;
}

export function makeDocuSignApiConfig(
  input: {
    baseUrl: string,
    rsaPrivateKey: string,
    userId: string,
    oAuth: OAuthConfig,
  }
): DocuSignApiConfig {
  return {
    baseUrl: input.baseUrl,
    rsaPrivateKey: input.rsaPrivateKey,
    userId: input.userId,
    oAuth: input.oAuth,
  };
}

const DocuSignApiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"baseUrl","default":{"kind":"nothing"},"name":"baseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"rsaPrivateKey","default":{"kind":"nothing"},"name":"rsaPrivateKey","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"oAuth","default":{"kind":"nothing"},"name":"oAuth","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"OAuthConfig"}},"parameters":[]}}]}},"name":"DocuSignApiConfig","version":{"kind":"nothing"}}};

export const snDocuSignApiConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"DocuSignApiConfig"};

export function texprDocuSignApiConfig(): ADL.ATypeExpr<DocuSignApiConfig> {
  return {value : {typeRef : {kind: "reference", value : snDocuSignApiConfig}, parameters : []}};
}

export interface FronteggConfig {
  /**
   * The domain URL of the Frontegg Environment
   */
  domainUrl: string;
  /**
   * The frontegg API URL that is used regardless of environment. 
   */
  apiUrl: string;
  /**
   * Application ID of the Main App in Frontegg
   */
  mainAppId: string;
  /**
   * Client ID of the Frontegg Environment
   */
  clientId: string;
  /**
   * API Key of the Frontegg Environment
   */
  apiKey: string;
  /**
   * Default Tenant ID (used by the user migration)
   */
  defaultTenantId: string;
  /**
   * Secret key for the jwt generation prehook
   */
  jwtPrehookSecret: string;
  /**
   * Additional issuer URLs accepted on inbound JWTs. Frontegg applications
   * with their own hosted-login URL emit a different `iss` from the
   * env-level domainUrl, but tokens are env-shared otherwise (signing
   * keys, audience). Defaults to empty.
   */
  additionalIssuers: string[];
}

export function makeFronteggConfig(
  input: {
    domainUrl: string,
    apiUrl: string,
    mainAppId: string,
    clientId: string,
    apiKey: string,
    defaultTenantId: string,
    jwtPrehookSecret: string,
    additionalIssuers?: string[],
  }
): FronteggConfig {
  return {
    domainUrl: input.domainUrl,
    apiUrl: input.apiUrl,
    mainAppId: input.mainAppId,
    clientId: input.clientId,
    apiKey: input.apiKey,
    defaultTenantId: input.defaultTenantId,
    jwtPrehookSecret: input.jwtPrehookSecret,
    additionalIssuers: input.additionalIssuers === undefined ? [] : input.additionalIssuers,
  };
}

const FronteggConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"The domain URL of the Frontegg Environment\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"domainUrl","default":{"kind":"nothing"},"name":"domainUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The frontegg API URL that is used regardless of environment. \n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"apiUrl","default":{"kind":"nothing"},"name":"apiUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Application ID of the Main App in Frontegg\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"mainAppId","default":{"kind":"nothing"},"name":"mainAppId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Client ID of the Frontegg Environment\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"clientId","default":{"kind":"nothing"},"name":"clientId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"API Key of the Frontegg Environment\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"apiKey","default":{"kind":"nothing"},"name":"apiKey","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Default Tenant ID (used by the user migration)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"defaultTenantId","default":{"kind":"nothing"},"name":"defaultTenantId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Secret key for the jwt generation prehook\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"jwtPrehookSecret","default":{"kind":"nothing"},"name":"jwtPrehookSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Additional issuer URLs accepted on inbound JWTs. Frontegg applications\nwith their own hosted-login URL emit a different `iss` from the\nenv-level domainUrl, but tokens are env-shared otherwise (signing\nkeys, audience). Defaults to empty.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"additionalIssuers","default":{"kind":"just","value":[]},"name":"additionalIssuers","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"FronteggConfig","version":{"kind":"nothing"}}};

export const snFronteggConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"FronteggConfig"};

export function texprFronteggConfig(): ADL.ATypeExpr<FronteggConfig> {
  return {value : {typeRef : {kind: "reference", value : snFronteggConfig}, parameters : []}};
}

/**
 * Configuration for Raw Data extraction jobs
 */
export interface RawExportConfig {
  /**
   * Number of threads for parent job orchestration (1 for sequential job processing)
   */
  parentJobThreads: number;
  batchThreads: number;
  /**
   * Connection pool size per snapshot database (sized for batchThreads + parent ctx)
   */
  connectionPoolSize: number;
  /**
   * Minimum refresh delay for connection pool in milliseconds
   */
  connectionPoolRefreshDelayMs: number;
  /**
   * Connection wait timeout in milliseconds (how long to wait for available connection)
   */
  connectionWaitTimeoutMs: number;
  /**
   * Batch size for processing FDP records
   */
  batchSize: number;
  /**
   * Maximum retry attempts for S3 uploads
   */
  maxRetryAttempts: number;
  /**
   * Base delay in milliseconds for retry backoff
   */
  retryBaseDelayMs: number;
  /**
   * Number of end-of-month dates to calculate FSP for (used by DealLeg FDP)
   */
  fspMonthsToCalculate: number;
  /**
   * Job metadata retention period in hours (cleanup after completion)
   */
  jobMetadataRetentionHours: number;
  /**
   * Cap on the number of batches exported per dataset (0 = unlimited). Used to bound work in
   * lower environments so a job finishes before the next ECS deploy restarts the container.
   */
  maxBatchesPerDataset: number;
}

export function makeRawExportConfig(
  input: {
    parentJobThreads?: number,
    batchThreads?: number,
    connectionPoolSize?: number,
    connectionPoolRefreshDelayMs?: number,
    connectionWaitTimeoutMs?: number,
    batchSize?: number,
    maxRetryAttempts?: number,
    retryBaseDelayMs?: number,
    fspMonthsToCalculate?: number,
    jobMetadataRetentionHours?: number,
    maxBatchesPerDataset?: number,
  }
): RawExportConfig {
  return {
    parentJobThreads: input.parentJobThreads === undefined ? 1 : input.parentJobThreads,
    batchThreads: input.batchThreads === undefined ? 16 : input.batchThreads,
    connectionPoolSize: input.connectionPoolSize === undefined ? 20 : input.connectionPoolSize,
    connectionPoolRefreshDelayMs: input.connectionPoolRefreshDelayMs === undefined ? 60000 : input.connectionPoolRefreshDelayMs,
    connectionWaitTimeoutMs: input.connectionWaitTimeoutMs === undefined ? 5000 : input.connectionWaitTimeoutMs,
    batchSize: input.batchSize === undefined ? 1000 : input.batchSize,
    maxRetryAttempts: input.maxRetryAttempts === undefined ? 3 : input.maxRetryAttempts,
    retryBaseDelayMs: input.retryBaseDelayMs === undefined ? 1000 : input.retryBaseDelayMs,
    fspMonthsToCalculate: input.fspMonthsToCalculate === undefined ? 12 : input.fspMonthsToCalculate,
    jobMetadataRetentionHours: input.jobMetadataRetentionHours === undefined ? 24 : input.jobMetadataRetentionHours,
    maxBatchesPerDataset: input.maxBatchesPerDataset === undefined ? 0 : input.maxBatchesPerDataset,
  };
}

const RawExportConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[{"value":"Configuration for Raw Data extraction jobs\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Number of threads for parent job orchestration (1 for sequential job processing)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"parentJobThreads","default":{"kind":"just","value":1},"name":"parentJobThreads","typeExpr":{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}},{"annotations":[],"serializedName":"batchThreads","default":{"kind":"just","value":16},"name":"batchThreads","typeExpr":{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}},{"annotations":[{"value":"Connection pool size per snapshot database (sized for batchThreads + parent ctx)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"connectionPoolSize","default":{"kind":"just","value":20},"name":"connectionPoolSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}},{"annotations":[{"value":"Minimum refresh delay for connection pool in milliseconds\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"connectionPoolRefreshDelayMs","default":{"kind":"just","value":60000},"name":"connectionPoolRefreshDelayMs","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"value":"Connection wait timeout in milliseconds (how long to wait for available connection)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"connectionWaitTimeoutMs","default":{"kind":"just","value":5000},"name":"connectionWaitTimeoutMs","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"value":"Batch size for processing FDP records\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"batchSize","default":{"kind":"just","value":1000},"name":"batchSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"value":"Maximum retry attempts for S3 uploads\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"maxRetryAttempts","default":{"kind":"just","value":3},"name":"maxRetryAttempts","typeExpr":{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}},{"annotations":[{"value":"Base delay in milliseconds for retry backoff\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"retryBaseDelayMs","default":{"kind":"just","value":1000},"name":"retryBaseDelayMs","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"value":"Number of end-of-month dates to calculate FSP for (used by DealLeg FDP)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"fspMonthsToCalculate","default":{"kind":"just","value":12},"name":"fspMonthsToCalculate","typeExpr":{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}},{"annotations":[{"value":"Job metadata retention period in hours (cleanup after completion)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"jobMetadataRetentionHours","default":{"kind":"just","value":24},"name":"jobMetadataRetentionHours","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"value":"Cap on the number of batches exported per dataset (0 = unlimited). Used to bound work in\nlower environments so a job finishes before the next ECS deploy restarts the container.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"maxBatchesPerDataset","default":{"kind":"just","value":0},"name":"maxBatchesPerDataset","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"RawExportConfig","version":{"kind":"nothing"}}};

export const snRawExportConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"RawExportConfig"};

export function texprRawExportConfig(): ADL.ATypeExpr<RawExportConfig> {
  return {value : {typeRef : {kind: "reference", value : snRawExportConfig}, parameters : []}};
}

export type ApiConfigName = string;

const ApiConfigName_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"ApiConfigName","version":{"kind":"nothing"}}};

export const snApiConfigName: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"ApiConfigName"};

export function texprApiConfigName(): ADL.ATypeExpr<ApiConfigName> {
  return {value : {typeRef : {kind: "reference", value : snApiConfigName}, parameters : []}};
}

export interface ApiConfigValue_ApiDeck {
  kind: 'apiDeck';
  value: ApiDeckApiConfig;
}
export interface ApiConfigValue_FreightTransport {
  kind: 'freightTransport';
  value: FreightTransportApiConfig;
}
export interface ApiConfigValue_ShipEngine {
  kind: 'shipEngine';
  value: ShipEngineApiConfig;
}
export interface ApiConfigValue_DocuSign {
  kind: 'docuSign';
  value: DocuSignApiConfig;
}
export interface ApiConfigValue_Bloomberg {
  kind: 'bloomberg';
  value: BloombergApiConfig;
}

export type ApiConfigValue = ApiConfigValue_ApiDeck | ApiConfigValue_FreightTransport | ApiConfigValue_ShipEngine | ApiConfigValue_DocuSign | ApiConfigValue_Bloomberg;

export interface ApiConfigValueOpts {
  apiDeck: ApiDeckApiConfig;
  freightTransport: FreightTransportApiConfig;
  shipEngine: ShipEngineApiConfig;
  docuSign: DocuSignApiConfig;
  bloomberg: BloombergApiConfig;
}

export function makeApiConfigValue<K extends keyof ApiConfigValueOpts>(kind: K, value: ApiConfigValueOpts[K]) { return {kind, value}; }

const ApiConfigValue_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"apiDeck","default":{"kind":"nothing"},"name":"apiDeck","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"ApiDeckApiConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"freightTransport","default":{"kind":"nothing"},"name":"freightTransport","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"FreightTransportApiConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"shipEngine","default":{"kind":"nothing"},"name":"shipEngine","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"ShipEngineApiConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"docuSign","default":{"kind":"nothing"},"name":"docuSign","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"DocuSignApiConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"bloomberg","default":{"kind":"nothing"},"name":"bloomberg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"BloombergApiConfig"}},"parameters":[]}}]}},"name":"ApiConfigValue","version":{"kind":"nothing"}}};

export const snApiConfigValue: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"ApiConfigValue"};

export function texprApiConfigValue(): ADL.ATypeExpr<ApiConfigValue> {
  return {value : {typeRef : {kind: "reference", value : snApiConfigValue}, parameters : []}};
}

export interface ApiConfig {
  name: ApiConfigName;
  value: ApiConfigValue;
}

export function makeApiConfig(
  input: {
    name: ApiConfigName,
    value: ApiConfigValue,
  }
): ApiConfig {
  return {
    name: input.name,
    value: input.value,
  };
}

const ApiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"ApiConfigName"}},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"ApiConfigValue"}},"parameters":[]}}]}},"name":"ApiConfig","version":{"kind":"nothing"}}};

export const snApiConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"ApiConfig"};

export function texprApiConfig(): ADL.ATypeExpr<ApiConfig> {
  return {value : {typeRef : {kind: "reference", value : snApiConfig}, parameters : []}};
}

/**
 * Config file that is passed to the node server
 */
export interface NodeServerConfig {
  port: number;
  environment: string;
  releaseName: string;
  /**
   * Server-side logging config
   */
  logging: common_config_log.LogLevel;
  /**
   * Format of the logs emitted from the server
   */
  logType: LogType;
  db: common_config_db.PostgreSqlConfig;
  /**
   * Secret used to sign JWT tokens
   */
  jwtSecret: string;
  /**
   * Secret used to authenticate internal API calls between Java and Node appserver
   */
  internalApiSecret: string;
  otelGrpcUrl: string;
  slackNotificationToken: string;
  corsAllowedOrigins: string[];
  /**
   * PostHog configuration
   */
  postHogConfig: PostHogConfig;
  fronteggDomainUrl: string;
  /**
   * Queue connection configuration for BullMQ/Valkey
   */
  queueConnection: QueueConnectionConfig;
  javaApiDomainUrl: string;
  /**
   * The base URL of the tax API (e.g. http://localhost:8080)
   */
  taxApiBaseUrl: string;
  /**
   * M2M access token to authenticate calls from the Node server to the Java server
   */
  m2mAccessToken: string;
  analyticsServiceBaseUrl: string;
}

export function makeNodeServerConfig(
  input: {
    port: number,
    environment: string,
    releaseName: string,
    logging: common_config_log.LogLevel,
    logType?: LogType,
    db: common_config_db.PostgreSqlConfig,
    jwtSecret: string,
    internalApiSecret: string,
    otelGrpcUrl: string,
    slackNotificationToken: string,
    corsAllowedOrigins: string[],
    postHogConfig: PostHogConfig,
    fronteggDomainUrl: string,
    queueConnection: QueueConnectionConfig,
    javaApiDomainUrl: string,
    taxApiBaseUrl: string,
    m2mAccessToken: string,
    analyticsServiceBaseUrl?: string,
  }
): NodeServerConfig {
  return {
    port: input.port,
    environment: input.environment,
    releaseName: input.releaseName,
    logging: input.logging,
    logType: input.logType === undefined ? "text" : input.logType,
    db: input.db,
    jwtSecret: input.jwtSecret,
    internalApiSecret: input.internalApiSecret,
    otelGrpcUrl: input.otelGrpcUrl,
    slackNotificationToken: input.slackNotificationToken,
    corsAllowedOrigins: input.corsAllowedOrigins,
    postHogConfig: input.postHogConfig,
    fronteggDomainUrl: input.fronteggDomainUrl,
    queueConnection: input.queueConnection,
    javaApiDomainUrl: input.javaApiDomainUrl,
    taxApiBaseUrl: input.taxApiBaseUrl,
    m2mAccessToken: input.m2mAccessToken,
    analyticsServiceBaseUrl: input.analyticsServiceBaseUrl === undefined ? "" : input.analyticsServiceBaseUrl,
  };
}

const NodeServerConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[{"value":"Config file that is passed to the node server\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"port","default":{"kind":"nothing"},"name":"port","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"environment","default":{"kind":"nothing"},"name":"environment","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"releaseName","default":{"kind":"nothing"},"name":"releaseName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Server-side logging config\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"logging","default":{"kind":"nothing"},"name":"logging","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.log","name":"LogLevel"}},"parameters":[]}},{"annotations":[{"value":"Format of the logs emitted from the server\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"logType","default":{"kind":"just","value":"text"},"name":"logType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"LogType"}},"parameters":[]}},{"annotations":[],"serializedName":"db","default":{"kind":"nothing"},"name":"db","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.db","name":"PostgreSqlConfig"}},"parameters":[]}},{"annotations":[{"value":"Secret used to sign JWT tokens\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"jwtSecret","default":{"kind":"nothing"},"name":"jwtSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Secret used to authenticate internal API calls between Java and Node appserver\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"internalApiSecret","default":{"kind":"nothing"},"name":"internalApiSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"otelGrpcUrl","default":{"kind":"nothing"},"name":"otelGrpcUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"slackNotificationToken","default":{"kind":"nothing"},"name":"slackNotificationToken","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"corsAllowedOrigins","default":{"kind":"nothing"},"name":"corsAllowedOrigins","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"value":"PostHog configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"postHogConfig","default":{"kind":"nothing"},"name":"postHogConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"PostHogConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"fronteggDomainUrl","default":{"kind":"nothing"},"name":"fronteggDomainUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Queue connection configuration for BullMQ/Valkey\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"queueConnection","default":{"kind":"nothing"},"name":"queueConnection","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"QueueConnectionConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"javaApiDomainUrl","default":{"kind":"nothing"},"name":"javaApiDomainUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The base URL of the tax API (e.g. http://localhost:8080)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"taxApiBaseUrl","default":{"kind":"nothing"},"name":"taxApiBaseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"M2M access token to authenticate calls from the Node server to the Java server\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"m2mAccessToken","default":{"kind":"nothing"},"name":"m2mAccessToken","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"analyticsServiceBaseUrl","default":{"kind":"just","value":""},"name":"analyticsServiceBaseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"NodeServerConfig","version":{"kind":"nothing"}}};

export const snNodeServerConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"NodeServerConfig"};

export function texprNodeServerConfig(): ADL.ATypeExpr<NodeServerConfig> {
  return {value : {typeRef : {kind: "reference", value : snNodeServerConfig}, parameters : []}};
}

/**
 * Configuration for queue connection (Valkey/Redis)
 */
export interface QueueConnectionConfig {
  host: string;
  port: number;
}

export function makeQueueConnectionConfig(
  input: {
    host?: string,
    port?: number,
  }
): QueueConnectionConfig {
  return {
    host: input.host === undefined ? "localhost" : input.host,
    port: input.port === undefined ? 6379 : input.port,
  };
}

const QueueConnectionConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[{"value":"Configuration for queue connection (Valkey/Redis)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"host","default":{"kind":"just","value":"localhost"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"port","default":{"kind":"just","value":6379},"name":"port","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"QueueConnectionConfig","version":{"kind":"nothing"}}};

export const snQueueConnectionConfig: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"QueueConnectionConfig"};

export function texprQueueConnectionConfig(): ADL.ATypeExpr<QueueConnectionConfig> {
  return {value : {typeRef : {kind: "reference", value : snQueueConnectionConfig}, parameters : []}};
}

export type LogType = 'text' | 'json';
export const valuesLogType : LogType[] = ['text', 'json'];

const LogType_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.config","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"text","default":{"kind":"nothing"},"name":"text","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"json","default":{"kind":"nothing"},"name":"json","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"LogType","version":{"kind":"nothing"}}};

export const snLogType: ADL.ScopedName = {moduleName:"ferovinum.app.config", name:"LogType"};

export function texprLogType(): ADL.ATypeExpr<LogType> {
  return {value : {typeRef : {kind: "reference", value : snLogType}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.config.MockDashboardConfig" : MockDashboardConfig_AST,
  "ferovinum.app.config.QuickSightConfig" : QuickSightConfig_AST,
  "ferovinum.app.config.DatabricksConfig" : DatabricksConfig_AST,
  "ferovinum.app.config.EmbeddedDashboardProviderConfig" : EmbeddedDashboardProviderConfig_AST,
  "ferovinum.app.config.EmbeddedDashboardConfig" : EmbeddedDashboardConfig_AST,
  "ferovinum.app.config.ServerConfig" : ServerConfig_AST,
  "ferovinum.app.config.DevConfig" : DevConfig_AST,
  "ferovinum.app.config.MessageQueueConfig" : MessageQueueConfig_AST,
  "ferovinum.app.config.ClientLogConfig" : ClientLogConfig_AST,
  "ferovinum.app.config.OAuthConfig" : OAuthConfig_AST,
  "ferovinum.app.config.SmtpConfig" : SmtpConfig_AST,
  "ferovinum.app.config.EmailTransportConfig" : EmailTransportConfig_AST,
  "ferovinum.app.config.EmailNotificationsConfig" : EmailNotificationsConfig_AST,
  "ferovinum.app.config.SecretUrls" : SecretUrls_AST,
  "ferovinum.app.config.VisionApiConfig" : VisionApiConfig_AST,
  "ferovinum.app.config.BloombergApiConfig" : BloombergApiConfig_AST,
  "ferovinum.app.config.BloombergRequests" : BloombergRequests_AST,
  "ferovinum.app.config.BloombergConfig" : BloombergConfig_AST,
  "ferovinum.app.config.TrueLayerApiConfig" : TrueLayerApiConfig_AST,
  "ferovinum.app.config.BlobStoreConfig" : BlobStoreConfig_AST,
  "ferovinum.app.config.S3LocalBlobStoreConfig" : S3LocalBlobStoreConfig_AST,
  "ferovinum.app.config.LocalBlobStoreConfig" : LocalBlobStoreConfig_AST,
  "ferovinum.app.config.S3BlobStoreConfig" : S3BlobStoreConfig_AST,
  "ferovinum.app.config.HotjarConfig" : HotjarConfig_AST,
  "ferovinum.app.config.GoogleAnalyticsConfig" : GoogleAnalyticsConfig_AST,
  "ferovinum.app.config.PostHogConfig" : PostHogConfig_AST,
  "ferovinum.app.config.PurchaseRequestTimelineDurations" : PurchaseRequestTimelineDurations_AST,
  "ferovinum.app.config.AmsterdamWarehouseCompany" : AmsterdamWarehouseCompany_AST,
  "ferovinum.app.config.ReportingStoreConfig" : ReportingStoreConfig_AST,
  "ferovinum.app.config.ApiDeckApiConfig" : ApiDeckApiConfig_AST,
  "ferovinum.app.config.FreightTransportApiConfig" : FreightTransportApiConfig_AST,
  "ferovinum.app.config.ShipEngineApiConfig" : ShipEngineApiConfig_AST,
  "ferovinum.app.config.DocuSignApiConfig" : DocuSignApiConfig_AST,
  "ferovinum.app.config.FronteggConfig" : FronteggConfig_AST,
  "ferovinum.app.config.RawExportConfig" : RawExportConfig_AST,
  "ferovinum.app.config.ApiConfigName" : ApiConfigName_AST,
  "ferovinum.app.config.ApiConfigValue" : ApiConfigValue_AST,
  "ferovinum.app.config.ApiConfig" : ApiConfig_AST,
  "ferovinum.app.config.NodeServerConfig" : NodeServerConfig_AST,
  "ferovinum.app.config.QueueConnectionConfig" : QueueConnectionConfig_AST,
  "ferovinum.app.config.LogType" : LogType_AST
};
